/**
 * @readonly
 * @enum {string}
 */
export const LAUNCH_BANNER_VARIANTS = {
  RETURNING: 'returning',
  NEW: 'new',
};

/**
 * @param {Object} deps
 * @param {boolean} deps.isManager Only managers can act on it — they own the subscription page.
 * @param {boolean} deps.isDismissed
 * @param {boolean|null} deps.hasEverAudited Null while the answer is still being loaded.
 * @return {string|null} A `LAUNCH_BANNER_VARIANTS` value, or null when nothing should render.
 */
// eslint-disable-next-line import/prefer-default-export
export function resolveLaunchBannerVariant({ isManager, isDismissed, hasEverAudited }) {
  if (!isManager || isDismissed || (hasEverAudited === null)) {
    return null;
  }

  return hasEverAudited ? LAUNCH_BANNER_VARIANTS.RETURNING : LAUNCH_BANNER_VARIANTS.NEW;
} // resolveLaunchBannerVariant()
